import messages from './messages.tsx';

export const notificationTypeToNotificationProperties = {
	MULTIPLE_APPS_CONFLICTS: {
		message: messages.multipleAppsConflicted,
		type: 'warning' as const,
	},
	// remove with the fg('uim_multiple_apps_detected_notification_remove') FF clean up
	MULTIPLE_APPS_IN_CONTEXT: {
		message: messages.uimMultipleApps,
		type: 'information' as const,
	},
};
